interface InfoButtonProps {
  label: string;
  title: string;
  onClick: () => void;
}

function InfoButton({ label, title, onClick }: InfoButtonProps) {
  return (
    <button
      className="info-button"
      type="button"
      onClick={onClick}
      aria-label={label}
      title={title}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
    </button>
  );
}

export default InfoButton;
